import { Hourglass } from 'lucide-react';

export default function WaitingLobby({ participantName }) {
  return (
    <div className="relative min-h-screen flex flex-col bg-mp-bg-lightgreen font-body">
      <header className="w-full max-w-[420px] mx-auto flex items-center justify-between p-5">
        <span className="mp-eyebrow">Mikkel kviss</span>
        <span className="inline-flex items-center gap-1.5 bg-mp-bg-mint text-mp-darkgreen font-display font-bold text-[12px] px-3 py-1.5 rounded-full">
          Inne
        </span>
      </header>

      <main className="flex-1 w-full max-w-[360px] mx-auto flex flex-col items-center justify-center text-center px-6 pb-12">
        {/* Pulsating Mikkel mascot */}
        <div className="relative w-[160px] h-[160px] mb-8 flex items-center justify-center">
          <span
            className="absolute inset-2 rounded-full bg-mp-bg-lightgreen border border-mp-lime/40 animate-ping"
            style={{ animationDuration: '2s' }}
          />
          <span
            className="absolute inset-2 rounded-full bg-mp-bg-lightgreen border border-mp-lime/40 animate-ping"
            style={{ animationDuration: '2s', animationDelay: '1s' }}
          />
          <img
            src="/Mikkel tenker uten bakgrunn.png"
            alt=""
            className="relative w-[140px] h-auto z-10"
          />
        </div>

        <h1 className="font-display text-mp-darkgreen text-[32px] mb-2">
          Hei, {participantName || 'spelar'}!
        </h1>
        <p className="font-body text-mp-stone-700 text-[15px] leading-[1.5] max-w-[280px] mb-8">
          Mikkel og dei andre venene gjer seg klare. Når verten startar, kjem
          første spørsmål her.
        </p>

        <span className="inline-flex items-center gap-2 bg-white px-4 py-3 rounded-full font-display text-mp-darkgreen text-[14px] border border-[rgba(17,73,66,0.12)] shadow-mp-1">
          <Hourglass size={16} className="text-mp-teal" />
          Me ventar på <strong className="text-mp-teal">verten</strong>
        </span>
      </main>

      <footer className="text-center pb-6">
        <p className="font-body text-mp-stone-500 text-[12px]">Hald skjermen på!</p>
      </footer>
    </div>
  );
}
